import { render, staticRenderFns } from "./Benachrichtigungen.vue?vue&type=template&id=dc616f40"
import script from "./Benachrichtigungen.vue?vue&type=script&lang=js"
export * from "./Benachrichtigungen.vue?vue&type=script&lang=js"
import style0 from "./Benachrichtigungen.vue?vue&type=style&index=0&id=dc616f40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports